/**
 * Consent store. Marketing pixels MUST NOT load until consent.marketing === true.
 */

export type ConsentState = {
  decided: boolean;
  essential: true;
  analytics: boolean;
  marketing: boolean;
};

const DEFAULT: ConsentState = { decided: false, essential: true, analytics: false, marketing: false };
const STORAGE_KEY = "glg.consent.v1";
const subs = new Set<() => void>();
let cached: ConsentState = DEFAULT;
let initialized = false;

function load(): ConsentState {
  if (typeof window === "undefined") return DEFAULT;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return DEFAULT;
    const p = JSON.parse(raw);
    return { ...DEFAULT, ...p, essential: true };
  } catch {
    return DEFAULT;
  }
}

export function getConsent(): ConsentState {
  if (!initialized) {
    cached = load();
    initialized = true;
  }
  return cached;
}

export function subscribeConsent(fn: () => void): () => void {
  subs.add(fn);
  return () => {
    subs.delete(fn);
  };
}

export function setConsent(next: Partial<ConsentState>) {
  cached = { ...getConsent(), ...next, essential: true, decided: true };
  if (typeof window !== "undefined") {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(cached));
  }
  subs.forEach((fn) => fn());
}

export function acceptAll() {
  setConsent({ analytics: true, marketing: true });
}

export function rejectAll() {
  setConsent({ analytics: false, marketing: false });
}
